import React from "react";

interface NextStepsInfoProps {
  title: string;
  subtitle: string;
  showCheckMark: boolean;
  days?: string; // Parámetro opcional para la cantidad de días
}

const NextStepsInfo: React.FC<NextStepsInfoProps> = ({
  title,
  subtitle,
  showCheckMark,
  days,
}) => {
  return (
    <div className="Content h-[80px] bg-white rounded-3xl justify-start items-center gap-4 inline-flex">
      <div className="MainBody grow shrink basis-0 flex-col justify-start items-start inline-flex">
        <div className="Propuesta self-stretch text-[#303139] text-base font-medium ">
          {title}
        </div>
        <div className="Subtitle self-stretch text-[#8b8f9f] text-sm font-medium ">
          {subtitle}
        </div>
        {days && (
          <div className="ExtraText self-stretch text-[#b5b8c6] text-xs font-medium leading-[14.40px]">
            {days}
          </div>
        )}
      </div>
      {showCheckMark && (
        <div className="Toggle w-8 h-8 relative bg-[#5a6ed5] rounded-[32px] flex justify-center items-center">
          <div className="AttentionCheck w-6 h-6 text-white">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 16.17L4.83 12 3.41 13.41 9 19 21 7 19.59 5.59 9 16.17Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
      )}
    </div>
  );
};

export default NextStepsInfo;
